import React from 'react';
import '../../../css/loader.scss';

function Loader (props) {
  return (
    <div className={props.loader == 'middle' ? 'loader' : 'loader-bottom'}>
        <div className={props.loader == 'middle' ? "loader-container" : "loader-container-bottom"}>
            <div className="spinner"></div>
        </div>
    </div>
  )
}

export default Loader;
